var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendiente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1363_1805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5131 20.5086C14.3591 26.6823 3.75744 24.3172 0.763082 16.1782C-2.76912 6.57923 6.58333 -2.76805 16.1818 0.762127C24.3352 3.76094 26.6684 14.3343 20.5131 20.5086ZM11.3044 1.79881C3.27491 2.34925 -1.01065 11.6037 3.78923 18.1098C8.20702 24.0992 17.4101 23.4458 20.9912 16.9505C24.9004 9.86025 19.344 1.24837 11.3037 1.79881H11.3044Z",
    fill: "#DE8509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8637 5.93704C12.8637 5.45998 12.4769 5.07324 11.9997 5.07324C11.5226 5.07324 11.1357 5.45998 11.1357 5.93704V14.1135C11.1357 14.5906 11.5226 14.9773 11.9997 14.9773C12.4769 14.9773 12.8637 14.5906 12.8637 14.1135V5.93704Z",
    fill: "#DE8509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 18.926C12.5277 18.926 12.9552 18.4985 12.9552 17.9713C12.9552 17.444 12.5277 17.0166 12.0003 17.0166C11.4729 17.0166 11.0454 17.444 11.0454 17.9713C11.0454 18.4985 11.4729 18.926 12.0003 18.926Z",
    fill: "#DE8509"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1363_1805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendiente);
export default __webpack_public_path__ + "static/media/pendiente.ec44dbbbddb3f131aebb07e94eb05a39.svg";
export { ForwardRef as ReactComponent };